<app-mat-spinner-overlay
  *ngIf="showWaitingForDataSpinner != 0"
  [overlay]="true"
>
</app-mat-spinner-overlay>

<nav class="navbar navbar-expand-md navbar-custom">
  <ul class="navbar-nav container container-navbar container-size">
    <li class="nav-item">
      <a class="nav-link" routerLinkActive="active" routerLink="/main"
        ><fa-icon [icon]="faHouseChimney" class="ml-1 header-icon"></fa-icon
        >Home</a
      >
    </li>

    <li class="nav-item">
      <a class="nav-link" routerLinkActive="active" routerLink="/hilfe"
        ><fa-icon [icon]="faQuestion" class="ml-1 header-icon"></fa-icon
        >Hilfe</a
      >
    </li>

    <div class="dropdown">
      <button
        class="nav-link dropdown-toggle"
        type="button"
        id="dropdownInformation"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <fa-icon [icon]="faInfo" class="ml-1 header-icon"></fa-icon>
        Informationen
      </button>
      <ul
        class="dropdown-menu cursor-hover"
        aria-labelledby="dropdownInformation"
      >
        <li>
          <a
            class="dropdown-item"
            routerLink="/definition-und-anwendungsbereich"
            routerLinkActive="active"
            >Definition und Anwendungsbereich</a
          >
        </li>

        <li>
          <a
            class="dropdown-item"
            routerLink="/abkuerzungsverzeichnis"
            routerLinkActive="active"
            >Abkürzungsverzeichnis</a
          >
        </li>

        <li>
          <a
            class="dropdown-item"
            routerLink="/literatur"
            routerLinkActive="active"
            >Literatur</a
          >
        </li>

        <li>
          <a
            class="dropdown-item"
            (click)="downloadFileBetriebsgroessenklassen()"
            >Betriebsgrößenklassen (<fa-icon
              [icon]="faDownload"
              class="ml-1 download-info"
              (click)="downloadFileBetriebsgroessenklassen()"
            ></fa-icon>
            {{ fileAppMetaDatas.betriebsgroessenklassen.endungText }}-Download
            {{ fileAppMetaDatas.betriebsgroessenklassen.sizeString }})</a
          >
        </li>
        <li>
          <a class="dropdown-item" (click)="downloadFileVerordnung()"
            >Durchführungsverordnung (EU) 2019/1975 (<fa-icon
              [icon]="faDownload"
              class="ml-1 download-info"
              (click)="downloadFileVerordnung()"
            ></fa-icon>
            {{ fileAppMetaDatas.verordnung.endungText }}-Download
            {{ fileAppMetaDatas.verordnung.sizeString }})</a
          >
        </li>
        <li>
          <a class="dropdown-item" (click)="downloadFileNutsZweiRegionen()"
            >NUTS-2 Regionen (<fa-icon
              [icon]="faDownload"
              class="ml-1 download-info"
              (click)="downloadFileNutsZweiRegionen()"
            ></fa-icon>
            {{ fileAppMetaDatas.nuts_zwei_regionen.endungText }}-Download
            {{ fileAppMetaDatas.nuts_zwei_regionen.sizeString }})</a
          >
        </li>

        <li>
          <a
            class="dropdown-item"
            routerLink="/pseudonymisierung-code"
            routerLinkActive="active"
            >Pseudonymisierung-Code</a
          >
        </li>
      
        <li>
          <a
            class="dropdown-item"
            routerLink="/pseudonymisierung-verfahren"
            routerLinkActive="active"
            >Pseudonymisierung-Verfahren</a
          >
        </li>

      </ul>
    </div>
  </ul>
</nav>
